import { Bodies, Body, Composite, Engine, Events, Render, Runner } from 'matter-js';

export default class GravityFalls {
  engine: Engine;
  render: Render;
  runner: Runner;
  ground: Body;
  leftWall: Body;
  rightWall: Body;
  fallingDivs: NodeListOf<Element> = document.querySelectorAll('.etape-recap');
  fallingEmoji: NodeListOf<Element> = document.querySelectorAll('.smiley-recap');

  start(wrapper: HTMLElement) {
    if (this.engine) return;
    // Créer un moteur et un monde
    this.engine = Engine.create();
    const { world } = this.engine;

    // Configuration du rendu
    this.render = Render.create({
      element: wrapper,
      engine: this.engine,
      options: {
        width: wrapper.clientWidth,
        height: wrapper.clientHeight,
        wireframes: false,
        background: 'transparent',
      },
    });

    // Lancer le moteur et le rendu
    Engine.run(this.engine);
    Render.run(this.render);
    this.runner = Runner.create();
    Runner.run(this.runner, this.engine);

    // Ajouter les murs pour contenir les divs
    this.ground = Bodies.rectangle(
      wrapper.clientWidth / 2,
      window.innerWidth < 990 ? wrapper.clientHeight - 25 : wrapper.clientHeight + 25,
      wrapper.clientWidth,
      50,
      {
        isStatic: true,
        render: {
          fillStyle: 'transparent',
          strokeStyle: 'transparent',
        },
      }
    );
    this.leftWall = Bodies.rectangle(-30, wrapper.clientHeight / 2, 50, wrapper.clientHeight, {
      isStatic: true,
      render: {
        fillStyle: 'transparent',
        strokeStyle: 'transparent',
      },
    });
    this.rightWall = Bodies.rectangle(
      wrapper.clientWidth + 30,
      wrapper.clientHeight / 2,
      50,
      wrapper.clientHeight,
      {
        isStatic: true,
        render: {
          fillStyle: 'transparent',
          strokeStyle: 'transparent',
        },
      }
    );
    Composite.add(world, [this.ground, this.leftWall, this.rightWall]);

    // Sélectionner toutes les divs à faire tomber et les ajouter au monde
    this.fallingDivs = document.querySelectorAll('.etape-recap');
    this.fallingDivs.forEach((div) => {
      const body = this.createFallingDiv(div);
      Composite.add(world, body);
    });
    this.fallingEmoji = document.querySelectorAll('.smiley-recap');
    this.fallingEmoji.forEach((div) => {
      const isTablet = window.innerWidth < 990;
      if ((isTablet && !div.classList.contains('hide-tablet')) || !isTablet) {
        const body = this.createFallingEmoji(div);
        Composite.add(world, body);
      }
    });
    // Redimensionner le canvas à chaque changement de la taille de la fenêtre
    window.addEventListener('resize', this.resizeHandler.bind(this));
  }

  stop() {
    if (!this.engine || !this.render || !this.runner) return;

    Runner.stop(this.runner);
    Render.stop(this.render);
    Engine.clear(this.engine);
    this.render.canvas.remove();
    this.render.textures = {};

    this.engine = null;
    this.render = null;
    this.runner = null;
    window.removeEventListener('resize', this.resizeHandler.bind(this));
    // Réinitialiser la position des divs à leur position d'origine
    this.fallingDivs.forEach((div) => {
      div.style.left = '';
      div.style.top = '';
      div.style.transform = '';
    });
    this.fallingEmoji.forEach((div) => {
      div.style.left = '';
      div.style.top = '';
      div.style.transform = '';
    });
  }

  createFallingDiv(div: HTMLElement): Body {
    const rect = div.getBoundingClientRect();
    const body = Bodies.rectangle(
      rect.left + rect.width / 2,
      rect.top + rect.height / 2,
      rect.width,
      rect.height,
      {
        restitution: 0.5,
        friction: 0.1,
        render: {
          fillStyle: 'transparent',
          strokeStyle: 'transparent',
        },
      }
    );

    // Synchroniser la position du corps avec la div
    Events.on(this.engine!, 'afterUpdate', () => {
      div.style.left = `${body.position.x - rect.width / 2}px`;
      div.style.top = `${body.position.y - rect.height / 2}px`;
      div.style.transform = `rotate(${body.angle}rad)`;
    });

    return body;
  }
  createFallingEmoji(div: HTMLElement): Body {
    const rect = div.getBoundingClientRect();
    const radius = rect.width / 2;
    const body = Bodies.circle(rect.left + radius, rect.top + radius, radius - 18, {
      restitution: 0.5,
      friction: 0.1,
      render: {
        fillStyle: 'transparent',
        strokeStyle: 'transparent',
      },
    });

    // Synchroniser la position du corps avec la div
    Events.on(this.engine!, 'afterUpdate', () => {
      div.style.left = `${body.position.x - radius}px`;
      div.style.top = `${body.position.y - radius}px`;
      div.style.transform = `rotate(${body.angle}rad)`;
    });

    return body;
  }

  resizeHandler() {
    if (!this.render) return;

    this.render.bounds.max.x = window.innerWidth;
    this.render.bounds.max.y = window.innerHeight;
    this.render.options.width = window.innerWidth;
    this.render.options.height = window.innerHeight;

    if (this.ground && this.rightWall) {
      Body.setPosition(this.ground, { x: window.innerWidth / 2, y: window.innerHeight + 25 });
      Body.setPosition(this.rightWall, { x: window.innerWidth + 25, y: window.innerHeight / 2 });
    }
  }
}
